import * as Yup from 'yup'

const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/

export const brandEditSchema = Yup.object().shape({
  primaryColor: Yup.string()
    .required('Cor primária é obrigatória')
    .matches(colorRegex, 'Precisa ser uma cor hexadecimal válida'),
  primaryActiveColor: Yup.string()
    .required('Cor primária ativa é obrigatória')
    .matches(colorRegex, 'Precisa ser uma cor hexadecimal válida'),
  asideColor: Yup.string()
    .required('Cor do menu lateral é obrigatória')
    .matches(colorRegex, 'Precisa ser uma cor hexadecimal válida'),
  logo: Yup.mixed<File>()
    .notRequired()
    .test('fileType', 'Apenas arquivos de imagem são permitidos', (value) => {
      if (!value) return true
      return ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'].includes(
        value.type
      )
    }),
  imagemLateral: Yup.mixed<File>()
    .notRequired()
    .test('fileType', 'Apenas arquivos de imagem são permitidos', (value) => {
      if (!value) return true
      return ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'].includes(
        value.type
      )
    }),
})
